module.exports = __webpack_public_path__ + "static/img/Jordan-De-Goey.6d6d96b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jordan-De-Goey.jpg
// module id = FWXQ
// module chunks = 0